import useToken from 'hooks/useToken';
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useToast } from 'context/providers/ToastProvider';
import FalconCloseButton from 'components/common/FalconCloseButton';
import { Badge, Button, Col, Form, InputGroup, Modal, Row, Spinner } from "react-bootstrap";
import { FaBox, FaSearch, FaShoppingCart, FaTimes } from 'react-icons/fa';
import ProductoTarjeta from './ProductoTarjeta';

const ModalProductos = (
    {
        mostrarModal,
        setMostrarModal,
        ObtenerProductoPorID,
        productosAgregados
    }

) => {
    const { token, setToken } = useToken();
    const { showErrorToast } = useToast();
    const [productos, setProductos] = useState([]);
    const [productosFiltrados, setProductosFiltrados] = useState([]);
    const [cargando, setCargando] = useState(false);
    const [agregando, setAgregando] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");


    useEffect(() => {
        if (mostrarModal) {
            ObtenerProductos();
        }
    }, [mostrarModal]);

    useEffect(() => {
        // Filtrar productos cuando cambia el término de búsqueda
        if (searchTerm.trim() === "") {
            setProductosFiltrados(productos);
        } else {
            const filtered = productos.filter(producto =>
                producto.vNombreProducto?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                producto.vCodigoBarras?.toLowerCase().includes(searchTerm.toLowerCase())
            );
            setProductosFiltrados(filtered);
        }
    }, [searchTerm, productos]);


    /**
    * Obtiene productos
    */
    const ObtenerProductos = async () => {
        setCargando(true);

        const response = await fetch("/api/Facturas/ObtenerProductos",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);

            });

        if (response?.ok) {
            setCargando(false);
            console.log("==== OBTENER PRODUCTOS ====");

            const data = await response.json();
            console.log("dataPDCS: ", data);

            if (data.iResponseType == 1) {
                var ObjDetalles = JSON.parse(data.detalles);
                console.log("ObjDetallesPD:", ObjDetalles);
                setProductos(ObjDetalles.table2);
                setProductosFiltrados(ObjDetalles.table2);
            } else {
                
                showErrorToast(data.vMessage);
            }

        }
        else {
            setCargando(false);
            
            showErrorToast(response?.status + ' ' + response?.statusText);
            if (response?.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    /**
     * Agregar producto al carrito
     */
    const handleAgregarProducto = async (idProducto) => {
        setAgregando(idProducto);
        try {
            await ObtenerProductoPorID(idProducto);
        } finally {
            setAgregando(null);
        }
    };

    /**
     * Verificar si un producto ya fue agregado
     */
    const yaAgregado = (idProducto) => {
        return productosAgregados.some(prod => prod.idProducto === idProducto);
    };

    return (
        <Modal
            show={mostrarModal}
            onHide={() => setMostrarModal(false)}
            size="xl"
            backdrop="static"
            aria-labelledby="modal-seleccionar-producto"
            centered
            scrollable
        >
            <Modal.Header
                style={{
                    background: 'linear-gradient(135deg, #009bdb 0%, #007a9e 100%)',
                    borderBottom: 'none',
                    paddingBottom: '20px',
                }}
            >
                <div className="w-100">
                    <div className="d-flex justify-content-between align-items-center">
                        <Modal.Title
                            id="modal-seleccionar-producto"
                            style={{ color: 'white', fontWeight: '600', fontSize: '1.3rem' }}
                        >
                            <FaShoppingCart className="me-2" />
                            Seleccionar Producto
                        </Modal.Title>
                        <FalconCloseButton
                            className="btn btn-circle btn-sm transition-base p-0"
                            onClick={() => { setMostrarModal(false); }}
                            style={{
                                backgroundColor: 'rgba(255,255,255,0.2)',
                                color: 'white',
                            }}
                        />
                    </div>

                    {/* Barra de búsqueda en el header */}
                    <div className="mt-3">
                        <InputGroup>
                            <InputGroup.Text
                                style={{
                                    backgroundColor: 'white',
                                    borderRight: 'none',
                                }}
                            >
                                <FaSearch style={{ color: '#009bdb' }} />
                            </InputGroup.Text>
                            <Form.Control
                                type="text"
                                placeholder="Buscar por nombre o código de barras..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                style={{
                                    borderLeft: 'none',
                                    fontSize: '0.9rem',
                                }}
                            />
                            {searchTerm && (
                                <Button
                                    variant="light"
                                    onClick={() => setSearchTerm("")}
                                    style={{ borderLeft: 'none' }}
                                >
                                    <FaTimes />
                                </Button>
                            )}
                        </InputGroup>
                    </div>

                    {/* Información de resultados */}
                    <div className="mt-2 d-flex justify-content-between align-items-center">
                        <small style={{ color: 'rgba(255,255,255,0.9)' }}>
                            {productosFiltrados.length} producto{productosFiltrados.length !== 1 ? 's' : ''} encontrado{productosFiltrados.length !== 1 ? 's' : ''}
                        </small>
                        <Badge bg="light" text="dark" style={{ fontSize: '0.75rem' }}>
                            {productosAgregados.length} agregado{productosAgregados.length !== 1 ? 's' : ''}
                        </Badge>
                    </div>
                </div>
            </Modal.Header>

            <Modal.Body
                className="bg-dark"
                style={{
                    minHeight: '500px',
                    maxHeight: '600px',
                }}
            >
                {cargando ? (
                    <div className="text-center py-5">
                        <Spinner animation="border" variant="primary" style={{ width: '3rem', height: '3rem' }} />
                        <p className="mt-3 text-light">Cargando productos...</p>
                    </div>
                ) : productosFiltrados.length === 0 ? (
                    <div className="text-center py-5">
                        <FaBox size={60} color="#d0d0d0" className="mb-3" />
                        <h5 className="text-muted">No se encontraron productos</h5>
                        <p className="text-light small">
                            {searchTerm ? 'Intenta con otro término de búsqueda' : 'No hay productos disponibles'}
                        </p>
                    </div>
                ) : (
                    <Row className="g-3">
                        {productosFiltrados.map((producto) => (
                            <Col key={producto.idProducto} xs={12} sm={6} md={4} lg={3}>
                                <ProductoTarjeta
                                    producto={producto}
                                    agregado={yaAgregado(producto.idProducto)}
                                    cargandoEsteProducto={agregando === producto.idProducto}
                                    onAgregarProducto={handleAgregarProducto}
                                />
                            </Col>
                        ))}
                    </Row>
                )}
            </Modal.Body>

            <Modal.Footer
                className="bg-dark border-secondary"
                style={{
                    borderTop: '1px solid #e0e0e0',
                }}
            >
                <div className="d-flex justify-content-between align-items-center w-100">
                    <div>
                        <span className="text-light small">
                            Total de productos: <strong>{productos.length}</strong>
                        </span>
                    </div>
                    <Button
                        variant="secondary"
                        onClick={() => setMostrarModal(false)}
                        style={{
                            borderRadius: '6px',
                            fontWeight: '500',
                        }}
                    >
                        <FaTimes className="me-2" />
                        Cerrar
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

ModalProductos.propTypes = {
    mostrarModal: PropTypes.bool.isRequired,
    setMostrarModal: PropTypes.func.isRequired,
    ObtenerProductoPorID: PropTypes.func.isRequired,
    productosAgregados: PropTypes.array
};

export default ModalProductos;